import { render } from "./VMarocchino.vue?vue&type=template&id=40d36fbc"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VMarocchino.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40d36fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40d36fbc', __exports__)) {
    api.reload('40d36fbc', __exports__)
  }
  
  module.hot.accept("./VMarocchino.vue?vue&type=template&id=40d36fbc", () => {
    api.rerender('40d36fbc', render)
  })

}


export default __exports__